import React from 'react';
import { Link } from 'react-router-dom';
import { useStore, KEYS, waLink, telLink, prettyPhone } from '../../admin/store';
import { FaFacebookF, FaYoutube, FaInstagram, FaEnvelope, FaPhone, FaWhatsapp } from 'react-icons/fa';

function Footer() {
  const info = useStore(KEYS.settings);
  return (
    <footer className="bg-gradient-to-r from-blue-500 via-blue-700 to-blue-900 text-white">
      {/* Main Footer Content */}
      <div className="max-w-7xl mx-auto px-6 py-12 grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-10 text-center md:text-left">

        {/* Logo + Description */}
        <div>
          <img
            src="/assets/logo.svg"
            alt="MM Autotech Logo"
            className="h-20 mb-4 mx-auto md:mx-0 transition-transform duration-300 hover:scale-110"
          />
          <p className="text-sm leading-relaxed text-gray-300">
            <p className="text-sm leading-relaxed text-gray-300">
              Professional garage, recovery & marketing services tailored for businesses across the UK.
            </p>          </p>
          <div className="flex justify-center md:justify-start mt-4 space-x-4">
            <a href="https://www.facebook.com/mmautotechlimited/" target="_blank" rel="noopener noreferrer" aria-label="Facebook">
              <FaFacebookF className="cursor-pointer hover:text-yellow-300 text-lg" />
            </a>
            <a href="https://www.youtube.com/@mmautotechofficial" target="_blank" rel="noopener noreferrer" aria-label="YouTube">
              <FaYoutube className="cursor-pointer hover:text-yellow-300 text-lg" />
            </a>
            <a href="https://www.instagram.com/mmautotechltd/" target="_blank" rel="noopener noreferrer" aria-label="Instagram">
              <FaInstagram className="cursor-pointer hover:text-yellow-300 text-lg" />
            </a>
          </div>
        </div>

        {/* Quick Links */}
        <div>
          <h3 className="text-yellow-400 font-bold text-xl mb-4">Quick Links</h3>
          <ul className="space-y-2 text-gray-300 text-sm">
            <li><Link to="/" className="hover:text-white">Home</Link></li>
            <li><Link to="/services" className="hover:text-white">Services</Link></li>
            <li><Link to="/about" className="hover:text-white">About</Link></li>
            <li><Link to="/contact" className="hover:text-white">Contact</Link></li>
          </ul>
        </div>

        {/* Contact Info */}
        <div>
          <h3 className="text-yellow-400 font-bold text-xl mb-4">Contact Us</h3>
          <p className="text-sm text-gray-300">
            <span className="font-semibold">UK Office:</span><br />
            {info.addressLine1}<br />
            {info.addressLine2}
          </p>
          <p className="flex items-center justify-center md:justify-start gap-2 mt-3 text-blue-300 text-sm">
            <FaEnvelope />
            <a href={`mailto:${info.email}`} className="hover:underline">
              {info.email}
            </a>
          </p>
          <p className="flex items-center justify-center md:justify-start gap-2 text-blue-300 mt-1 text-sm">
            <FaWhatsapp />
            <a href={waLink(info.whatsapp)} target="_blank" rel="noopener noreferrer" className="hover:underline">{prettyPhone(info.whatsapp)}</a>
          </p>
          {info.phone && info.phone !== info.whatsapp && (
            <p className="flex items-center justify-center md:justify-start gap-2 text-blue-300 mt-1 text-sm">
              <FaPhone />
              <a href={telLink(info.phone)} className="hover:underline">{prettyPhone(info.phone)}</a>
            </p>
          )}
          {info.landline && (
            <p className="flex items-center justify-center md:justify-start gap-2 text-blue-300 mt-1 text-sm">
              <FaPhone />
              <a href={telLink(info.landline)} className="hover:underline">{info.landline}</a>
            </p>
          )}
        </div>

        {/* Business Hours */}
        <div>
          <h3 className="text-yellow-400 font-bold text-xl mb-4">Business Hours</h3>
          <p className="text-sm text-gray-300">{info.hoursWeekdays}</p>
          <p className="text-sm text-gray-300">{info.hoursWeekend}</p>
        </div>
      </div>

      {/* Bottom Strip */}
      <div className="border-t border-blue-700 text-sm text-center py-4 px-6 flex flex-col sm:flex-row justify-between items-center bg-blue-900">
        <p className="mb-2 sm:mb-0">© 2025 MM Auto Tech. All Rights Reserved.</p>
        <p>Powered by MM Auto Tech</p>
      </div>
    </footer>
  );
}

export default Footer;
